import queryString from 'query-string';
import { ENDPOINTS } from 'config/endpoints';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';

export interface DeleteTemplateAttachmentInput {
  templateId: number;
  attachmentId: number;
}

type DeleteTemplateAttachmentVars = DeleteTemplateAttachmentInput;

export default function useDeleteTemplateAttachment() {
  const queryClient = useQueryClient();

  const deleteTemplateAttachment = (input: DeleteTemplateAttachmentVars) => {
    const queryParams = queryString.stringify(input);

    const request: Request = {
      url: `${ENDPOINTS.template.attachment.main}?${queryParams}`,
      config: {
        method: 'delete',
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<
    Response<null>,
    CronoError,
    DeleteTemplateAttachmentVars
  >(deleteTemplateAttachment, {
    onSettled: () =>
      queryClient.invalidateQueries([ENDPOINTS.template.attachment.main]),
  });

  return { data, mutate, ...rest };
}
